import { CreditsPerMonth, CreditsPerYear } from 'constants/credits';
import React from 'react';
import { Interval } from 'types/generated/subscriptionsApi';
import { Trans } from '@lingui/macro';
import Plan from '../Plan/Plan';
import { useUpsellActionsContext } from '../../context/UpsellActionsContext';
import useSamplePlan from './useSamplePlan';

const SampleUsp = ({ frequency }: { frequency: Interval }) => (
    <ul>
        <li>
            {frequency === 'Monthly' ? (
                <Trans>{CreditsPerMonth} credits per month</Trans>
            ) : (
                <Trans>{CreditsPerYear} credits per year</Trans>
            )}
        </li>
        <li>
            <Trans>Weekly pack giveaway</Trans>
        </li>
    </ul>
);

const SamplePlan = () => {
    const {
        frequency,
        hasSubscription,
        samplesCatalog,
        selectedPlan,
        getSaleDiscount,
        handlePlanSelect,
    } = useUpsellActionsContext();

    const {
        code,
        currency,
        info,
        monthlyEquivalentPrice,
        monthlyEquivalentSale,
        salePrice,
        subscriptionPrice,
        title,
    } = useSamplePlan({
        frequency,
        hasSubscription,
        samplesCatalog,
        getSaleDiscount,
    });

    return (
        <Plan
            activePlanCode={selectedPlan}
            code={code}
            currency={currency}
            frequency={frequency}
            monthlyEquivalentPrice={monthlyEquivalentPrice}
            subscriptionPrice={subscriptionPrice}
            title={title}
            info={info}
            usp={<SampleUsp frequency={frequency} />}
            handlePlanSelect={handlePlanSelect}
            salePrice={salePrice}
            monthlyEquivalentSale={monthlyEquivalentSale}
        />
    );
};

export default SamplePlan;
